import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '@lean-body/components/styles';
import { HealthStarIcon } from '../atoms/icons/health_star_icon';
export const DiagnosisHealthLevelCard = ({ rating }) => {
    return (React.createElement("div", { className: css(styles.card) },
        React.createElement("div", { className: css(styles.cardTitle) }, "\u5065\u5EB7\u30EC\u30D9\u30EB"),
        React.createElement("div", { className: css(styles.starRow) }, [0, 1, 2, 3, 4].map((i) => {
            if (i < Math.floor(rating))
                return React.createElement(HealthStarIcon, { key: i, fill: "full" });
            if (i === Math.floor(rating) && rating % 1 >= 0.5)
                return React.createElement(HealthStarIcon, { key: i, fill: "half" });
            return React.createElement(HealthStarIcon, { key: i, fill: "empty" });
        }))));
};
const styles = StyleSheet.create({
    card: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    cardTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        color: Colors.Black,
        letterSpacing: 0.48,
        marginBottom: 4,
    },
    starRow: {
        display: 'flex',
    },
});
